import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { ResumeLibraryType } from '../Actions'
import {
  GET_ASSIGN_BATCH_LIST,
  GET_ASSIGN_TO_BATCH_SKILL_MATCH,
  GET_JD_DETAILS,
  GET_JD_LIST,
  GET_RESUME_FILE,
  RESUME_ACTIVITY,
  RESUME_ASSIGN_TO_BATCH,
  RESUME_BULK_BOOKMARK,
  RESUME_BULK_DELETE,
  RESUME_BULK_DOWNLOAD,
  RESUME_LIBRARY,
  RESUME_LIBRARY_ASSIGN_HISTORY,
  RESUME_LIBRARY_DETAIL,
} from '../constants/action-types'

const initialState = {
  isLoadingResumeList: false,
  resumeList: [],
  isLoadingResumeDetail: false,
  resumeDetail: {},
  isLoadingResumeAssignHistory: false,
  resumeAssignHistory: {},
  isLoadingResumeActivity: false,
  resumeActivity: {},
  isLoadingResumeFile: false,
  resumeFile: {},
  isLoadingAssignBatchList: false,
  assignBatchList: [],
  isLoadingAssignBatchSkillMatchList: false,
  assignBatchSkillMatchList: [],
  isLoadingResumeBulkDelete: false,
  isLoadingResumeBulkBookmark: false,
  isLoadingJdList: false,
  JdList: [],
  isLoadingResumeAssignToBatch: false,
  isLoadingJdDetails: false,
  jdDetails: {},
  isLoadingResumeBulkFile: false,
  resumeBulkFile: [],
}

const resumeLibraryReducer = persistReducer(
  { storage, key: 'resume-library', whitelist: [] },
  (state: ResumeLibraryType = initialState, action: ActionTypes) => {
    switch (action.type) {
      //Resume list
      case RESUME_LIBRARY.RESUME_LIBRARY_LIST_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeList: true,
        }

      case RESUME_LIBRARY.RESUME_LIBRARY_LIST_SUCCESS:
        return {
          ...state,
          isLoadingResumeList: false,
          resumeList: action.payload,
        }

      case RESUME_LIBRARY.RESUME_LIBRARY_LIST_ERROR:
        return {
          ...state,
          isLoadingResumeList: false,
        }
      //Resume details
      case RESUME_LIBRARY_DETAIL.RESUME_LIBRARY_DETAIL_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeDetail: true,
        }

      case RESUME_LIBRARY_DETAIL.RESUME_LIBRARY_DETAIL_SUCCESS:
        return {
          ...state,
          isLoadingResumeDetail: false,
          resumeDetail: action.payload,
        }

      case RESUME_LIBRARY_DETAIL.RESUME_LIBRARY_DETAIL_ERROR:
        return {
          ...state,
          isLoadingResumeDetail: false,
        }

      //Resume assign history
      case RESUME_LIBRARY_ASSIGN_HISTORY.RESUME_LIBRARY_ASSIGN_HISTORY_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeAssignHistory: true,
        }

      case RESUME_LIBRARY_ASSIGN_HISTORY.RESUME_LIBRARY_ASSIGN_HISTORY_SUCCESS:
        return {
          ...state,
          isLoadingResumeAssignHistory: false,
          resumeAssignHistory: action.payload,
        }

      case RESUME_LIBRARY_ASSIGN_HISTORY.RESUME_LIBRARY_ASSIGN_HISTORY_ERROR:
        return {
          ...state,
          isLoadingResumeAssignHistory: false,
        }

      //Resume activity
      case RESUME_ACTIVITY.RESUME_ACTIVITY_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeActivity: true,
        }

      case RESUME_ACTIVITY.RESUME_ACTIVITY_SUCCESS:
        return {
          ...state,
          isLoadingResumeActivity: false,
          resumeActivity: action.payload,
        }

      case RESUME_ACTIVITY.RESUME_ACTIVITY_ERROR:
        return {
          ...state,
          isLoadingResumeActivity: false,
        }
      //Resume file
      case GET_RESUME_FILE.GET_RESUME_FILE_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeFile: true,
        }

      case GET_RESUME_FILE.GET_RESUME_FILE_SUCCESS:
        return {
          ...state,
          isLoadingResumeFile: false,
          resumeFile: action.payload,
        }

      case GET_RESUME_FILE.GET_RESUME_FILE_ERROR:
        return {
          ...state,
          isLoadingResumeFile: false,
        }
      //Assign batch list
      case GET_ASSIGN_BATCH_LIST.GET_ASSIGN_BATCH_LIST_INITIALIZATION:
        return {
          ...state,
          isLoadingAssignBatchList: true,
        }

      case GET_ASSIGN_BATCH_LIST.GET_ASSIGN_BATCH_LIST_SUCCESS:
        return {
          ...state,
          isLoadingAssignBatchList: false,
          assignBatchList: action.payload,
        }

      case GET_ASSIGN_BATCH_LIST.GET_ASSIGN_BATCH_LIST_ERROR:
        return {
          ...state,
          isLoadingAssignBatchList: false,
        }

      //Assign batch skill match list
      case GET_ASSIGN_TO_BATCH_SKILL_MATCH.GET_ASSIGN_TO_BATCH_SKILL_MATCH_INITIALIZATION:
        return {
          ...state,
          isLoadingAssignBatchSkillMatchList: true,
        }

      case GET_ASSIGN_TO_BATCH_SKILL_MATCH.GET_ASSIGN_TO_BATCH_SKILL_MATCH_SUCCESS:
        return {
          ...state,

          isLoadingAssignBatchSkillMatchList: false,
          assignBatchSkillMatchList: action.payload,
        }

      case GET_ASSIGN_TO_BATCH_SKILL_MATCH.GET_ASSIGN_TO_BATCH_SKILL_MATCH_ERROR:
        return {
          ...state,
          isLoadingAssignBatchSkillMatchList: false,
        }
      //Resume bulk delete
      case RESUME_BULK_DELETE.RESUME_BULK_DELETE_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeBulkDelete: true,
        }

      case RESUME_BULK_DELETE.RESUME_BULK_DELETE_SUCCESS:
        return {
          ...state,
          isLoadingResumeBulkDelete: false,
        }

      case RESUME_BULK_DELETE.RESUME_BULK_DELETE_ERROR:
        return {
          ...state,
          isLoadingResumeBulkDelete: false,
        }
      //Resume bulk bookmark
      case RESUME_BULK_BOOKMARK.RESUME_BULK_BOOKMARK_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeBulkBookmark: true,
        }

      case RESUME_BULK_BOOKMARK.RESUME_BULK_BOOKMARK_SUCCESS:
        return {
          ...state,
          isLoadingResumeBulkBookmark: false,
        }

      case RESUME_BULK_BOOKMARK.RESUME_BULK_BOOKMARK_ERROR:
        return {
          ...state,
          isLoadingResumeBulkBookmark: false,
        }
      //jd list
      case GET_JD_LIST.GET_JD_LIST_INITIALIZATION:
        return {
          ...state,
          isLoadingJdList: true,
        }

      case GET_JD_LIST.GET_JD_LIST_SUCCESS:
        return {
          ...state,
          isLoadingJdList: false,
          JdList: action.payload,
        }

      case GET_JD_LIST.GET_JD_LIST_ERROR:
        return {
          ...state,
          isLoadingJdList: false,
        }
      //resume assign to batch
      case RESUME_ASSIGN_TO_BATCH.RESUME_ASSIGN_TO_BATCH_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeAssignToBatch: true,
        }
      case RESUME_ASSIGN_TO_BATCH.RESUME_ASSIGN_TO_BATCH_SUCCESS:
        return {
          ...state,
          isLoadingResumeAssignToBatch: false,
        }
      case RESUME_ASSIGN_TO_BATCH.RESUME_ASSIGN_TO_BATCH_ERROR:
        return {
          ...state,
          isLoadingResumeAssignToBatch: false,
        }
      //get jd details
      case GET_JD_DETAILS.GET_JD_DETAILS_INITIALIZATION:
        return {
          ...state,
          isLoadingJdDetails: true,
        }
      case GET_JD_DETAILS.GET_JD_DETAILS_SUCCESS:
        return {
          ...state,
          isLoadingJdDetails: false,
          jdDetails: action.payload,
        }
      case GET_JD_DETAILS.GET_JD_DETAILS_ERROR:
        return {
          ...state,
          isLoadingJdDetails: false,
        }
      //get resume bulk download
      case RESUME_BULK_DOWNLOAD.RESUME_BULK_DOWNLOAD_INITIALIZATION:
        return {
          ...state,
          isLoadingResumeBulkFile: true,
        }
      case RESUME_BULK_DOWNLOAD.RESUME_BULK_DOWNLOAD_SUCCESS:
        return {
          ...state,
          isLoadingResumeBulkFile: false,
          resumeBulkFile: action.payload,
        }
      case RESUME_BULK_DOWNLOAD.RESUME_BULK_DOWNLOAD_ERROR:
        return {
          ...state,
          isLoadingResumeBulkFile: false,
        }
      default:
        return state
    }
  }
)

export default resumeLibraryReducer
